import React, {useEffect} from "react";
import Hero from "./Hero";
import About from "./About";
import Occasion from "./Occasion";
import Shop from "./Shop";
import Dhoti from "./Dhoti";
import Malai from "./Malai";
import Contact from "./Contact";
import NewArrival from "./NewArrival";
import Trending from "./Trending";
import Last from "./Last";
import Custom from "./Custom";
import Shorts from "./Shorts";
import Bestselling from "./Bestselling";
import Pattu from "./Pattu";

const Home = () => {

 useEffect(() => {
    const sectionId = window.location.pathname.slice(1); // Remove the leading slash
    const sectionElement = document.getElementById(sectionId);
    if (sectionElement) {
      sectionElement.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <div className='bg-[#fff]'>
<section className='mt-24 ' id="homeSection">
      <Hero />
</section>
<section id="aboutSection">
      <About />
       <Bestselling/>
      <Occasion />
     <NewArrival/>
     <Trending/>
</section>
<section id="collectionSection">
     
      <Shop />
      <Custom/>
      <Shorts/>
      <Pattu/>
      <Dhoti />
      <Malai />
</section>
 <section id="contactSection">
      <Contact />
      <Last/>

</section>
    </div>
  );
};

export default Home;
